import axios from 'axios'

const API_URL = 'https://api.districtcoolingarboleda.com/api'

const api = axios.create({ baseURL: API_URL })

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(err)
  }
)

export const authService = {
  login: (email, password) => api.post('/auth/login', { email, password }),
}

export const locatariosService = {
  listar: (params) => api.get('/locatarios', { params }),
  obtener: (id) => api.get(`/locatarios/${id}`),
  crear: (data) => api.post('/locatarios', data),
  actualizar: (id, data) => api.put(`/locatarios/${id}`, data),
  exportarExcel: () => api.get('/locatarios/exportar-excel', { responseType: 'blob' }),
}

export const ticketsService = {
  dashboardMetricas: () => api.get('/tickets/dashboard-metricas'),
  listar: (params) => api.get('/tickets', { params }),
  obtener: (id) => api.get(`/tickets/${id}`),
  crear: (data) => api.post('/tickets', data),
  actualizar: (id, data) => api.put(`/tickets/${id}`, data),
  responder: (id, data) => api.post(`/tickets/${id}/responder`, data),
  estadisticas: (params) => api.get('/tickets/estadisticas', { params }),
  vincular: (id, locatarioId) => api.put(`/tickets/${id}/vincular`, { locatarioId }),
  descartar: (id) => api.put(`/tickets/${id}/descartar`),
  subirArchivo: (file) => {
    const formData = new FormData()
    formData.append('archivo', file)
    return api.post('/tickets/subir-archivo', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  reporteExcel: (params) => api.get('/tickets/reporte/excel', { params, responseType: 'blob' }),
  reportePDF: (params) => api.get('/tickets/reporte/pdf', { params, responseType: 'blob' }),
}



export const comunicadosService = {
  listar: () => api.get('/comunicados'),
  generar: (instrucciones) => api.post('/comunicados/generar', { instrucciones }),
  crear: (data) => api.post('/comunicados', data),
  publicar: (id) => api.put(`/comunicados/${id}/publicar`),
  subirArchivo: (file) => {
    const formData = new FormData()
    formData.append('archivo', file)
    return api.post('/comunicados/subir-archivo', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
}

export const pagosService = {
  listar: (params) => api.get('/pagos', { params }),
  morosos: () => api.get('/pagos/morosos'),
  estadoCuenta: (locatarioId) => api.get(`/pagos/estado-cuenta/${locatarioId}`),
  registrarAbono: (data) => api.post('/pagos/abono', data),
  registrarDeuda: (data) => api.post('/pagos/deuda', data),
}

export const formulariosService = {
  obtenerTicket: (ticketId) => api.get(`/formularios/ticket/${ticketId}`),
  actualizarDatos: (ticketId, data) => api.post(`/formularios/actualizar-datos/${ticketId}`, data),
  cotizacionMantenimiento: (ticketId, data) => api.post(`/formularios/cotizacion-mantenimiento/${ticketId}`, data),
  actualizacionesPorTicket: (ticketId) => api.get('/formularios/actualizaciones-datos/ticket/' + ticketId),
  aprobarActualizacion: (id) => api.post('/formularios/actualizaciones-datos/' + id + '/aprobar'),
  rechazarActualizacion: (id) => api.post('/formularios/actualizaciones-datos/' + id + '/rechazar'),
}

export const actualizacionesService = {
  listar: (params) => api.get('/actualizaciones-datos', { params }),
  confirmar: (id, data) => api.put(`/actualizaciones-datos/${id}/confirmar`, data),
}

export const solicitudesMantenimientoService = {
  listar: (params) => api.get('/solicitudes-mantenimiento', { params }),
  actualizar: (id, data) => api.put(`/solicitudes-mantenimiento/${id}`, data),
}

export default api
